import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setupReminders" }
const _hoisted_2 = { class: "setupReminders_content" }
const _hoisted_3 = { class: "setupReminders_head" }
const _hoisted_4 = { class: "setupReminders_title" }
const _hoisted_5 = { class: "setupReminders_desc" }
const _hoisted_6 = { class: "setupReminders_actions" }

import { useRouter } from 'vue-router'
import { MqResponsive, useMq } from 'vue3-mq'

import PAGE_NAME from '@web/consts/PAGE_NAME'
import AcButton from '@ui-kit/components/AcButton.vue'
import AcImage from '@web/ui-kit/components/AcImage/index.vue'
import { postFirstDayModalCtaClicked, postFirstDayModalRedirectReminders } from '@web/services/Analytics/events'
import type { CloseMethod } from '@web/services/Analytics/events/postFirstDayModal'
import illustrationMobile from '@web/assets.v2/post-first-day/reminders-illustration-mobile.jpg'
import illustrationDesktop from '@web/assets.v2/post-first-day/reminders-illustration-desktop.jpg'


export default /*@__PURE__*/_defineComponent({
  __name: 'SetupRemindersContent',
  emits: ["close", "cta"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const router = useRouter()
const mq = useMq()

function platformView (): 'mobile_web' | 'desktop_web' {
  return mq.current === 'desktop' ? 'desktop_web' : 'mobile_web'
}

function onCta (): void {
  postFirstDayModalCtaClicked({ modalType: 'setup_reminders', platformView: platformView() })
  postFirstDayModalRedirectReminders({ platformView: platformView() })
  router.push({ name: PAGE_NAME.SETTINGS_REMINDERS_TRAINING, state: { autoEnableReminders: true } })
  emit('cta')
}

function onClose (method: CloseMethod): void {
  emit('close', method)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MqResponsive), {
      target: "mobile-tablet",
      class: "setupReminders_illustration"
    }, {
      default: _withCtx(() => [
        _createVNode(AcImage, {
          src: _unref(illustrationMobile),
          "aspect-ratio": "720 / 566",
          "object-fit": "cover",
          alt: ""
        }, null, 8, ["src"]),
        _createElementVNode("button", {
          class: "setupReminders_close -onImage",
          "data-test": "setup-close",
          "aria-label": "Закрыть",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose('cross_button')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("g", { "clip-path": "url(#clip0_24929_239821)" }, [
              _createElementVNode("path", {
                d: "M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z",
                fill: "white"
              })
            ]),
            _createElementVNode("defs", null, [
              _createElementVNode("clipPath", { id: "clip0_24929_239821" }, [
                _createElementVNode("rect", {
                  width: "28",
                  height: "28",
                  fill: "white"
                })
              ])
            ])
          ], -1)
        ]))]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "setupReminders_illustrationGradient" }, null, -1))
      ]),
      _: 1
    }),
    _createVNode(_unref(MqResponsive), {
      target: "desktop",
      class: "setupReminders_illustration -desktop"
    }, {
      default: _withCtx(() => [
        _createVNode(AcImage, {
          src: _unref(illustrationDesktop),
          "aspect-ratio": "766 / 582",
          "object-fit": "cover",
          alt: ""
        }, null, 8, ["src"]),
        _createElementVNode("button", {
          class: "setupReminders_close -onImage",
          "data-test": "setup-close",
          "aria-label": "Закрыть",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onClose('cross_button')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            width: "28",
            height: "28",
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("g", { "clip-path": "url(#clip0_24929_239821)" }, [
              _createElementVNode("path", {
                d: "M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z",
                fill: "white"
              })
            ]),
            _createElementVNode("defs", null, [
              _createElementVNode("clipPath", { id: "clip0_24929_239821" }, [
                _createElementVNode("rect", {
                  width: "28",
                  height: "28",
                  fill: "white"
                })
              ])
            ])
          ], -1)
        ]))]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "setupReminders_illustrationGradient" }, null, -1))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('postFirstDayModal.remindersTitle')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('postFirstDayModal.remindersDesc')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(AcButton, {
          block: "",
          "data-test": "setup-cta",
          onClick: onCta
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('postFirstDayModal.remindersCta')), 1)
          ]),
          _: 1
        }),
        _createVNode(AcButton, {
          class: "setupReminders_action -text",
          block: "",
          variant: "text",
          "data-test": "setup-later",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose('secondary_button')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('postFirstDayModal.maybeLater')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})